import { PropsWithChildren } from 'react';

import styles from '../../WizardLayout.module.scss';

export const TopNavigation = ({ children }: PropsWithChildren) => {
  return <nav className={styles.topNavigation}>{children}</nav>;
};
